import React, { Component } from 'react';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import Alert from 'react-s-alert';
import { Field, reduxForm, reset } from 'redux-form';
import classNames from 'classnames';

import MaintenanceLevelsModal from './maintenanceLevel_Modal';
import { renderTextField } from '../../../components/reduxFields';
import { alertConfirmation, resetFiltersAndSorting } from '../../../actions/utilAction';
import SortingCustom from '../../../components/SortingCustom';
import { getMaintenanceLevelsList, getMasterData, deleteMaintenanceLevels } from './actions/MaintenanceLevelsActions';
import Tooltip from '../../../components/Tooltip';
import PaginatorCustom from '../../../components/paginationCustom';

class ManageMaintenanceLevels extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            maintenanceLevelId: null,
        }
        this.filter = {
            sort_Column: '',
            sort_order: '',
            searchText: '',
        };
        this.handleSearchMaintenanceLevels = this.handleSearchMaintenanceLevels.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.setSortColumn = this.setSortColumn.bind(this);
    }

    componentWillMount() {
        this.loadData();
        let masterData = { 'masterdata': 'MASTERCOLLECTIONFREQUENCY' };
        this.props.getMasterData(masterData);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.saved_maintenanceLevel && nextProps.saved_maintenanceLevel !== this.props.saved_maintenanceLevel) {
            this.loadData();
        }
        if (nextProps.deleted_maintenanceLevel && nextProps.deleted_maintenanceLevel !== this.props.deleted_maintenanceLevel) {
            this.loadData();
        }
    }

    componentWillUnmount() {
        Alert.closeAll();
    }

    loadData(page_number) {
        let searchObj = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_order || '',
            contain_filters: { SearchText: this.filter.searchText || null },
            pageNumber: page_number || 1,
        };
        this.props.getMaintenanceLevelsList(searchObj);
    }

    handleOpen = () => {
        Alert.closeAll();
        this.setState({ open: true, maintenanceLevelId: null });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleSearchMaintenanceLevels() {
        return false;
    }

    handleSearchChange(event) {
        if (event.target.value.length > 2) {
            this.filter.searchText = event.target.value;
            this.loadData();
        } else if (event.target.value.length === 0) {
            this.filter.searchText = '';
            this.loadData();
        }
    }

    handleReset = () => {
        Alert.closeAll();
        this.props.dispatch(reset('ManageMaintenanceLevelsForm'));
        resetFiltersAndSorting(this.filter, 'id', true);
        this.filter.sort_Column = '';
        this.filter.sort_order = '';
        this.loadData();
    };

    setSortColumn(col_name, col_order) {
        if (col_name) {
            this.filter.sort_Column = col_name;
            this.filter.sort_order = col_order;
            this.loadData();
        }
    }

    handleEditClick = (event, obj) => {
        Alert.closeAll();
        this.setState({ open: true, maintenanceLevelId: obj.id });
    }

    handleAlertClick = (event, maintenanceLevelId) => {
        this.props.deleteMaintenanceLevels(maintenanceLevelId);
        Alert.closeAll();
    }

    handleDeleteClick = (event, obj) => {
        alertConfirmation('Are you sure you want to delete Maintenance Level details?', {
            customFields: {
                displayComponent: true,
                handleButtonClick: this.handleAlertClick,
                id: obj.id,
            },
        });
    }

    renderData(maintenanceLevelList) {
        maintenanceLevelList = maintenanceLevelList || [];
        if (!maintenanceLevelList.length) {
            return (
                <tr>
                    <td colSpan="4">
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        return maintenanceLevelList.map((Obj, index) => {
            return (
                <tr key={index}>
                    <td>{Obj.name}</td>
                    <td>{Obj.collectionFrequencyName}</td>
                    <td className={Obj.isActive === true ? 'greenfont' : 'redfont'}>{Obj.isActive ? 'Yes' : 'No'}</td>
                    {this.props.updatePermission || this.props.deletePermission ?
                        <td>
                            {this.props.updatePermission ?
                                <button onClick={(e) => this.handleEditClick(e, Obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                                : null
                            }
                            {this.props.deletePermission ?
                                <button onClick={(e) => this.handleDeleteClick(e, Obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                                : null
                            }
                        </td>
                        : null
                    }
                </tr>
            )
        })
    }

    render() {
        const { handleSubmit, maintenanceLevelData } = this.props;
        let maintenanceLevelList = (maintenanceLevelData && maintenanceLevelData.data) || [];
        let maintenanceLevelMeta = (maintenanceLevelData && maintenanceLevelData.meta) || null
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        return (
            <div>
                <h2 className="page_title">Manage Maintenance Levels <Tooltip Description='Maintenance levels are used to specify how often targets are revisited, or "probed," once they have reached mastery criteria. You can have any number of maintenance levels, each with its own prompting interval. These levels will then be used for EACH student.' /></h2>
                <div className="clearfix"></div>
                <div className="readmin-panel">
                    <div className="panel-body">
                        <div className="modalwindow">
                            <div className="row">
                                <div className="col-sm-5">
                                    {this.props.addPermission ?
                                        <div>
                                            <RaisedButton label="Add Maintenance Level" primary={true} onTouchTap={this.handleOpen} />  <Tooltip Description='To add a new maintenance level, click the "Add Maintenance Level" button. Choose a name for the level and specify a collection frequency.' />
                                        </div>
                                        : null}
                                </div>
                                <div className="col-sm-7">
                                    <div className="row end-flex">
                                        <div className="col-sm-6 mtm-27">
                                            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchMaintenanceLevels)}>
                                                <Field
                                                    name="maintenanceLevels"
                                                    floatingLabelText="Search"
                                                    maxLength='15'
                                                    onChange={this.handleSearchChange}
                                                    component={renderTextField}
                                                />
                                            </form>
                                        </div>
                                        <div className="reset-btn col-sm-3 btn_rt">
                                            <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {this.state.open && <MaintenanceLevelsModal maintenanceLevelId={this.state.maintenanceLevelId} closeDialog={this.handleClose} />}
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="table-responsive mt-15">
                                    <table className={tableClass}>
                                        <thead>
                                            <tr>
                                                <th width="30%"><SortingCustom noSort={!maintenanceLevelList.length} setSortColumn={this.setSortColumn} columnName='name' displayName='Name' /></th>
                                                <th width="40%"><SortingCustom noSort={!maintenanceLevelList.length} setSortColumn={this.setSortColumn} columnName='collectionFrequencyName' displayName='Collection Frequency' /></th>
                                                <th width="20%">Active</th>
                                                {this.props.updatePermission || this.props.deletePermission ?
                                                    <th width="10%">Actions</th>
                                                    : null
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.renderData(maintenanceLevelList)}
                                        </tbody>
                                    </table>
                                    {maintenanceLevelMeta && maintenanceLevelMeta['totalPages'] ?
                                        <PaginatorCustom data={maintenanceLevelMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
                                        : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

ManageMaintenanceLevels = reduxForm({
    form: 'ManageMaintenanceLevelsForm',
})(ManageMaintenanceLevels);

function mapStateToProps(state) {

    // Start For Role Permission
    let userActionPermission = [];
    if (state.login.userPermission) {
        let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === "MASTERS_DATA_COLLECTION");
        let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === "MASTERS_DATA_COLLECTION_MAINTENANCE_LEVELS_LIST" && obj.moduleId === userModulePermission[0].moduleId);
        userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
    }

    let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

    let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "MASTERS_DATA_COLLECTION_MAINTENANCE_LEVELS_LIST_ADD")[0].permission : false;
    let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "MASTERS_DATA_COLLECTION_MAINTENANCE_LEVELS_LIST_UPDATE")[0].permission : false;
    let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "MASTERS_DATA_COLLECTION_MAINTENANCE_LEVELS_LIST_DELETE")[0].permission : false;

    // End For Role Permission

    return {
        loading: state.maintenanceLevels.loading,
        maintenanceLevelData: state.maintenanceLevels.maintenanceLevelsList,
        saved_maintenanceLevel: state.maintenanceLevels.saved_maintenanceLevelsList,
        deleted_maintenanceLevel: state.maintenanceLevels.deleted_maintenanceLevelsList,
        addPermission: addPermission, // For Role Permission
        updatePermission: updatePermission, // For Role Permission
        deletePermission: deletePermission // For Role Permission
    }
}

export default connect(mapStateToProps, { getMaintenanceLevelsList, getMasterData, deleteMaintenanceLevels })(ManageMaintenanceLevels);


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/maintenanceLevel/index.js